module.exports = __webpack_public_path__ + "static/banner-410525ffc7cc782d9a7718681ab4eb41.png";